// removed by extract-text-webpack-plugin
module.exports = {"image":"_3l1956FanIosLH6TQhGPMM","informations":"_20cbYOYBLqAeJ5am4No54d","profilePic":"_138Ftuu7bOdVagJ-D2nOj4","empty":"gzeClg2bzatLK7dkq1YHJ","loading":"_2f8JjT4q9BHupmSCEtI4dV","outfits":"_1XGozre-d1tFEJp-r8B2jc","outfit":"H29hN6eFtfZzpzY8vRB5L","loader":"_1Ud3MHKKIZUPlsO0C4J_xM","load8":"_2MQqDemOokYGVek_NoduQ8"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Profile/Profile.scss
 ** module id = 747
 ** module chunks = 0
 **/